import { initContract } from "@ts-rest/core";
import { z } from "zod";
import { SaveSaleProduct } from "../schemas/index.js";

const c = initContract();

export const saleProductContract = c.router({
  saveSaleProduct: {
    method: "POST",
    path: "/trade-sales/sale-product/save",
    responses: {
      [200]: z.object({ status: z.literal("success") }),
    },
    body: SaveSaleProduct,
    summary: "Save information for sale product",
  },

  getSaleProductsByProductId: {
    method: "GET",
    path: "/trade-sales/sale-product",
    query: z.object({
      productIds: z.coerce
        .string()
        .default("[]")
        .transform((v) => JSON.parse(v)),
    }),
    responses: {
      [200]: z.object({ saleProducts: z.array(SaveSaleProduct) }),
    },
    summary: "Get information for sale products by product ids",
  },
});
